import { Component } from '@angular/core';
import { PagesName } from 'src/app/shared/helpers/pagesName';
import { Router } from '@angular/router';
import { PermissionsHttpService } from 'src/app/shared/permissions-http-service/permissions-http.service';

@Component({
  selector: 'biomark-doc',
  styleUrls: ['./biomark.component.scss'],
  templateUrl: './biomark.component.html',
})
export class BiomarkDocComponent {
  canCreateProject = false

  constructor(private router: Router, private permissions: PermissionsHttpService) {
    this.permissions
    .checkPermission({
      permissions: {

        createProject:{}
      },
    })
    .subscribe((res) => {
      this.canCreateProject = res.createProject;
    });
  }
  createProject() {
    this.router.navigate([PagesName.ProjectCreation, PagesName.DefineProject,"biomark"])
  }
}
